import * as _ from 'lodash';
import { AttributeType } from '../enums/attribute-type.enum';

import IAttribute = ZoningAPI.IAttribute;

export class AttributeModel implements IAttribute {
    Id?: number;
    AttributeType?: number;
    AttributeValue?: string;

    constructor(data: IAttribute) {
        Object.assign(this, data);
    }

    get isLink(): boolean {
        return this.AttributeType === AttributeType.LINK;
    }

    get isComment(): boolean {
        return this.AttributeType === AttributeType.COMMENT;
    }

    get isAssumption(): boolean {
        return this.AttributeType === AttributeType.ASSUMPTION;
    }
}
